import { publicDatasetApi } from '@/features/publicDatasets/publicDatasetApi';
import { LAYER_USER_INTERACTION } from '@/actions/constants';

// @ts-expect-error: Infer proper types.
export const chartConfigMiddleware = (store) => (next) => (action) => {
  const nextAction = next(action);
  const nextState = store.getState();
  const { isPublic } = nextState.datasource;
  if (
    isPublic &&
    action.type === LAYER_USER_INTERACTION &&
    action.payload?.event === 'update-charting-options'
  ) {
    const { metadata, rowRequestId } = nextState.rows;
    const { datasourceId } = nextState.datasource;
    const { chartingOptions } = action.payload;

    if (chartingOptions && datasourceId && rowRequestId) {
      store.dispatch(
        publicDatasetApi.endpoints.savePublicDatasetMetadata.initiate({
          ...metadata,
          datasourceId,
          rowRequestId,
          chartingOptions,
        }),
      );
    }
  }
  return nextAction;
};
